// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import RssFeedRoundedIcon from '@mui/icons-material/RssFeedRounded';

// material ui
import {
  Box,
  Card,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
} from '@mui/material';

interface DataStream {
  UnitId: number;
  Name: string;
}

interface DataStreamDetailListProps {
  dataStreams: DataStream[];
}

const DataStreamDetailList = ({ dataStreams }: DataStreamDetailListProps) => {
  const { t } = useTranslation('energyxplorer');
  if (!dataStreams || dataStreams.length === 0) return null;

  return (
    <Card variant="outlined">
      <List
        dense
        subheader={
          <ListSubheader>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <RssFeedRoundedIcon fontSize="small" />
              {t('nodes.datastream_detail.associated_datastreams')}
              <Chip size="small" label={dataStreams.length} />
            </Box>
          </ListSubheader>
        }
      >
        <Divider />
        {dataStreams.map((stream) => (
          <ListItem key={stream.UnitId}>
            <ListItemText
              primary={stream.Name}
              secondary={`#${stream.UnitId}`}
            />
          </ListItem>
        ))}
      </List>
    </Card>
  );
};

export default DataStreamDetailList;
